
<template>
  <!--钥匙列表-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="pass_key_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="true"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-button type="link" @click="toMemeberDetail(row.member_id)">{{row.mobile}}</a-button>
      </template>

      <template slot="opt_t" slot-scope="{row}">
        <p @click="toDevDetail(row.device_id)">
          <a-button type="link">{{row.device_name}}</a-button>
          <br>
          <a-button type="link">{{row.device_position}}</a-button>
        </p>
      </template>

      <template slot="opt_h" slot-scope="{row}">
        <a-button type="link" @click="toApplyDetail(row.apply_id)" :disabled="row.apply_id===0">申请信息</a-button>
      </template>

      <template slot="opt_f" slot-scope="{row}">
        <span>{{row.expire_time | foreverTime}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'keyList',
  data () {
    return {
      cascadeParam: {},
      searchList: [
        { props: ['community_id'], placeholder: '小区名称', options: [], inputType: 'select', handle: ($event) => this.communityChange(6, $event) },
        { props: ['keywords'], placeholder: '设备名或编码', options: [], inputType: 'input' },
        { props: ['mobile_phone'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        { props: ['area_id'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['property_id'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['building_id'], placeholder: '楼栋', options: [], inputType: 'select', handle: ($event) => this.buildingChange(7, $event) },
        { props: ['unit_id'], placeholder: '单元', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '钥匙状态', options: this.$store.state.isExpireList, inputType: 'select' }
      ],
      tableOptList: [
        { text: '分配钥匙', icon: 'setting', handle: this.toAlloc, key: 'allocKey' },
        { text: '批量分配', icon: 'setting', handle: this.toBatchAlloc, key: 'bathAlloc' },
        { text: '删除', icon: 'colse', disabled: true, key: 'batchDel' }
      ],
      rowOptList: [
        { text: '删除', handle: (row) => this.$children[0].showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'pass_key_id', align: 'left', width: '' },
        { title: '住户', dataIndex: 'mobile', align: 'left', width: '', scopedSlots: {customRender: 'action_o'} },
        { title: '位置', dataIndex: 'position_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'device_name', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '申请信息', dataIndex: 'apply_content', align: 'left', width: '', scopedSlots: {customRender: 'action_h'} },
        { title: '到期时间', dataIndex: 'expire_time', align: 'left', width: '', scopedSlots: {customRender: 'action_f'} },
        { title: '添加时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: '',
        keywords: '',
        mobile_phone: '',
        create_date: [],
        area_id: [],
        property_id: '',
        building_id: '',
        unit_id: '',
        status: ''
      },
      listApi: {
        url: '/key_list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/key_list',
        param: { pk_key: 'pass_key_id', pk_val: '' },
        title: '住户钥匙',
        key: 'position_name'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      this.propertySelect(5);
      this.regionSelect(4);
    },
    /* 进入分配钥匙 */
    toAlloc () {
      this.$router.push({
        name: 'allocation'
      });
    },
    /* 进入批量分配钥匙 */
    toBatchAlloc () {
      this.$router.push({
        name: 'batchAllocation'
      });
    },
    /* 进入钥匙申请记录详情 */
    toApplyDetail (id) {
      this.$router.push({
        name: 'keyApplyDetail',
        query: {id: id}
      });
    },
    /* 进入设备详情 */
    toDevDetail (id) {
      this.$router.push({
        name: 'smartDoorDetail',
        query: {id: id}
      });
    },
    /* 进入会员详情 */
    toMemeberDetail (id) {
      this.$router.push({
        name: 'memberDetail',
        query: {id: id}
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/keyList/keyList.vue